module.exports = __webpack_public_path__ + "static/media/3playerRoomsPlayed_25000_50000.ce8e4a6d.png";